import React, { useState } from 'react'
import styled from 'styled-components'
import { Button, Text, useModal } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import { ToastDescriptionWithTx } from 'components/Toast'
import useCatchTxError from 'hooks/useCatchTxError'
import useToast from 'hooks/useToast'
import { BIG_ZERO } from 'utils/bigNumber'
import { LockV2Data } from '../../../types'
import useLockReward from '../../../hooks/v2/useLockReward'
import useLockToken from '../../../hooks/v2/useLockToken'
import LockTransferModal from './LockTransferModal'
import LockListModal from './LockListModal'

const Item = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.secondary};
  display: flex;
  margin-bottom: 4px;
`

const LockCardAction: React.FC<{ data: LockV2Data }> = ({ data }) => {
  const { t } = useTranslation()
  const [status, setStatus] = useState(false)

  const { id, listed } = data

  const { reward } = useLockReward(id)
  const { onClaim, onDelist, onUnlock } = useLockToken()
  const { toastSuccess } = useToast()
  const { fetchWithCatchTxError, loading: pendingTx } = useCatchTxError()

  const [onPresentTransferModal] = useModal(<LockTransferModal id={id} />,)
  const [onPresentListModal] = useModal(<LockListModal id={id} />,)

  const toggleStatus = () => {
    setStatus(!status)
  }

  const handleDelist = async () => {
    const receipt = await fetchWithCatchTxError(() => {
      return onDelist(id)
    })
    if (receipt?.status) {
      toastSuccess(
        `${t('Delisted')}!`,
        <ToastDescriptionWithTx txHash={receipt.transactionHash}>
          {t('Your lock has been delisted')}
        </ToastDescriptionWithTx>,
      )
      toggleStatus()
    }
  }

  return (
    <>
      <Item style={{ gap: '8px', marginTop: '16px' }}>
        <Button
          disabled={pendingTx || reward.isEqualTo(BIG_ZERO)}
          style={{ flex: '1' }}
          onClick={async () => {
            const receipt = await fetchWithCatchTxError(() => {
              return onClaim(id)
            })
            if (receipt?.status) {
              toastSuccess(
                `${t('Claimed')}!`,
                <ToastDescriptionWithTx txHash={receipt.transactionHash}>
                  {t('Claimed tokens have been sent to your wallet!')}
                </ToastDescriptionWithTx>,
              )
              toggleStatus()
            }
          }}
        >Claim Reward</Button>
        <Button
          disabled={pendingTx}
          style={{ flex: '1' }}
          onClick={async () => {
            const receipt = await fetchWithCatchTxError(() => {
              return onUnlock(id)
            })
            if (receipt?.status) {
              toastSuccess(
                `${t('Unlocked')}!`,
                <ToastDescriptionWithTx txHash={receipt.transactionHash}>
                  {t('Unlocked tokens have been sent to your wallet!')}
                </ToastDescriptionWithTx>,
              )
              toggleStatus()
            }
          }}
        >Unlock</Button>
      </Item>
      <Item style={{ gap: '8px', marginTop: '16px' }}>
        <Button
          disabled={pendingTx}
          style={{ flex: '1' }}
          onClick={onPresentTransferModal}
        >Transfer</Button>
        <Button
          disabled={pendingTx}
          style={{ flex: '1' }}
          onClick={() => {
            if (listed) handleDelist()
            else onPresentListModal()
          }}
        >{listed ? t('Delist') : t('List')}</Button>
      </Item>
    </>
  )
}

export default LockCardAction
